import React from 'react';

import './heading-tertiary.styles.scss';

const HeadingTertiatry = ({ text, className }) => (
  <h3 className={`${className} heading-tertiary`}>{text}</h3>
);

export default HeadingTertiatry;
